<template>
  <router-link :to="to" tag="li" class="tab-item" active-class="uk-active">
    <a class="tab-item__link">
      <icon v-if="icon" :name="icon" class="uk-margin-small-right" />
      <slot>{{text}}</slot>
    </a>
  </router-link>
</template>

<script>
export default {
  name: 'tab-item',
  props: {
    to: Object,
    text: String,
    icon: String,
  },
};
</script>

<style lang="scss" scoped>
.tab-item {
  user-select: none;
}
</style>



// WEBPACK FOOTER //
// TabItem.vue?475040b0